export default {"src":"/_next/static/media/literacy.fc2b94db.svg","height":26,"width":27,"blurWidth":0,"blurHeight":0};